module.exports = __webpack_public_path__ + "static/media/logo.8a8adb3d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.svg
// module id = 240
// module chunks = 0